import { createReducer, on } from '@ngrx/store';
import * as RewardsActions from './rewards.actions';
import { initialRewardsState } from './rewards.state';

export const rewardsReducer = createReducer(
  initialRewardsState,

  on(RewardsActions.loadRewards, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(RewardsActions.loadRewardsSuccess, (state, { rewards, pagination }) => ({
    ...state,
    rewards,
    loading: false,
    error: null,
    pagination,
  })),

  on(RewardsActions.loadRewardsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(RewardsActions.createReward, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(RewardsActions.createRewardSuccess, (state, { reward }) => ({
    ...state,
    rewards: [ ...state.rewards, reward ],
    loading: false,
    error: null,
  })),

  on(RewardsActions.createRewardFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(RewardsActions.updateReward, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(RewardsActions.updateRewardSuccess, (state, { reward }) => ({
    ...state,
    rewards: state.rewards.map(r => r.id === reward.id ? reward : r),
    loading: false,
    error: null,
  })),

  on(RewardsActions.updateRewardFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(RewardsActions.deleteReward, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(RewardsActions.deleteRewardSuccess, (state, { id }) => ({
    ...state,
    rewards: state.rewards.filter(r => r.id !== id),
    loading: false,
    error: null,
  })),

  on(RewardsActions.deleteRewardFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);
